import { map } from 'rxjs';
import { getUnixTime } from 'date-fns';
import { ADMIN_API } from '../AdminAPI';
import { convertUnixToDate } from '@golden/utils';
export function createAgentWalletService(api) {
    return {
        getHistories(payload) {
            const data = { ...payload };
            if (data.start_at)
                data.start_at = getUnixTime(data.start_at);
            if (data.end_at)
                data.end_at = getUnixTime(data.end_at);
            return api.fetch(ADMIN_API.GET_AGENT_WALLETS_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at'))
            })));
        },
        getSummary(data) {
            return api.fetch(ADMIN_API.GET_AGENT_WALLETS_SUMMARY, { data });
        },
        recharge(data) {
            return api.fetch(ADMIN_API.POST_AGENT_WALLETS_RECHARGE, { data });
        },
        revoke(data) {
            return api.fetch(ADMIN_API.POST_AGENT_WALLETS_REVOKE, { data });
        },
        agentTopUp(data) {
            return api.fetch(ADMIN_API.POST_AGENT_WALLETS_TOP_UP, { data });
        },
        agentDeduct(data) {
            return api.fetch(ADMIN_API.POST_AGENT_WALLETS_DEDUCT, { data });
        },
        agentManualDeposit(data) {
            return api.fetch(ADMIN_API.POST_AGENT_WALLETS_MANUAL_DEPOSIT, { data });
        }
    };
}
//# sourceMappingURL=AgentWalletService.js.map